require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/$.core').Array.from;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/fn/array/from.js
 ** module id = 20
 ** module chunks = 0
 **/